import { c as _c } from "react/compiler-runtime";
// updateContactInfo(
//   companyContact: CompanyContactInput!
//   userContact: UserContactInput!
// ): Company!

import { graphql, VariablesOf } from "@/graphql";
import { graphqlClient } from "@/lib/graphql-client";
import { useMutation } from "@tanstack/react-query";
const updateCompanyInfoMutation = graphql(`
  mutation updateContactInfo(
    $companyContact: CompanyContactInput!
    $userContact: UserContactInput!
  ) {
    updateContactInfo(
      companyContact: $companyContact
      userContact: $userContact
    ) {
      id
    }
  }
`);
export type UpdateCompanyInfoInput = VariablesOf<typeof updateCompanyInfoMutation>;
export function useUpdateCompanyInfoMutation() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
}
async function _temp(input) {
  return graphqlClient.request(updateCompanyInfoMutation, input);
}